import { getAuthHeaders } from './auth-headers';
import { throwResponseError } from './lock-error';

const API_URL = process.env.REACT_APP_CONVERSATIONS_API_URL;

// getAuthHeaders() is async (it acquires a fresh B2C token via MSAL), so every
// caller awaits it before issuing the request.
function headers() {
    return getAuthHeaders();
}

export async function listConversations(limit = 20, nextToken) {
    const params = new URLSearchParams({ limit: String(limit) });
    if (nextToken) params.set('nextToken', nextToken);

    const res = await fetch(`${API_URL}/conversations?${params}`, {
        headers: await headers(),
    });

    if (!res.ok) throw new Error(`Failed to list conversations: ${res.status}`);
    return res.json();
}

export async function getConversation(sessionId) {
    const res = await fetch(`${API_URL}/conversations/${sessionId}`, {
        headers: await headers(),
    });

    if (!res.ok) {
        if (res.status === 404) throw new Error('Conversation not found');
        throw new Error(`Failed to get conversation: ${res.status}`);
    }
    return res.json();
}

export async function createConversation(title) {
    const res = await fetch(`${API_URL}/conversations`, {
        method: 'POST',
        headers: await headers(),
        body: JSON.stringify({ title }),
    });

    if (!res.ok) throw new Error(`Failed to create conversation: ${res.status}`);
    return res.json();
}

export async function updateConversation(sessionId, data) {
    const res = await fetch(`${API_URL}/conversations/${sessionId}`, {
        method: 'PUT',
        headers: await headers(),
        body: JSON.stringify(data),
    });

    // A locked conversation (PRD pending/approved/rejected) answers 409 with
    // { error, code, reason }. throwResponseError raises a LockError the hook
    // branches on; any other non-OK stays a plain Error.
    if (!res.ok) await throwResponseError(res, `Failed to update conversation: ${res.status}`);
}

export async function deleteConversation(sessionId) {
    const res = await fetch(`${API_URL}/conversations/${sessionId}`, {
        method: 'DELETE',
        headers: await headers(),
    });

    if (!res.ok) throw new Error(`Failed to delete conversation: ${res.status}`);
}
